import React, { useContext } from "react";

import { AuthContext } from "../../contexts/authContext";
import lbl from "../../data/Labels.json";
import AriaAppLogo from "../../icons/aria-app-logo";
import AccountPasswordForm from "./AccountPasswordForm";

const ChangePasswordPage = () => {
  const { accountProfile, logOut } = useContext(AuthContext);

  const mustChangePassword =
    Number(accountProfile?.must_change_password) === 1 ||
    accountProfile?.must_change_password === true;
  const skipCurrentPassword =
    mustChangePassword || Number(accountProfile?.has_password) !== 1;

  const handleLogout = () => {
    if (typeof logOut === "function") logOut();
    else window.location.replace("/login.html");
  };

  return (
    <div className="change-password-page">
      <div className="change-password-shell">
        <div className="change-password-brand">
          <AriaAppLogo />
        </div>
        <header className="change-password-header">
          <h1>{mustChangePassword ? lbl.SetPassword || "تنظیم رمز عبور" : lbl.ChangePassword}</h1>
          <p>
            {mustChangePassword
              ? lbl.FirstLoginHint || "برای ادامه، رمز عبور جدید خود را تنظیم کنید."
              : lbl.AccountSecurityHint || "رمز ورود به سیستم را به‌روز کنید."}
          </p>
        </header>
        <section className="change-password-card">
          <AccountPasswordForm
            mustChangePassword={mustChangePassword}
            skipCurrentPassword={skipCurrentPassword}
            showBackLink={!mustChangePassword}
          />
        </section>
        {mustChangePassword ? (
          <div className="change-password-footer">
            <button type="button" className="change-password-logout" onClick={handleLogout}>
              {lbl.Logout}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ChangePasswordPage;
